import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SearchPraticesCtrl = function (fn, er, state, pratica, ebox, token, ids) {

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};

	var data = {
		ebox: ebox,
		order: state.selectedOrderValue === '' ? 'datascad' : state.selectedOrderValue,
		search: state.selectedCode,
		state: pratica
	};

	axios
		.post(ApiConfig.url.SEARCH_PRATICES, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { SearchPraticesCtrl };